import React from 'react';
import { Link } from 'react-router-dom'


const Servicios = (props) => {

    const data = props.data;

    return (
        <section className="tf-section montono" id='portfolio' style={{ paddingTop: '120px' }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="block-text center">
                            <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Servicios</span></h1>
                            <h5 className="sub-title mb-10 text-black" data-aos="fade-up" data-aos-duration="1000">Comodidades</h5>
                            <h3 className="title mb-28 text-black" data-aos="fade-up" data-aos-duration="1000">Espacios <br /> Comunes</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row mt-52">
                    {
                        data.slice(1, 7).map((data, index) => (
                            <div key={index} className="col-xl-4 col-md-6">
                                <div className="image-box" data-aos="fade-up" data-aos-duration="1000">
                                    <img src={data.img} alt="Monteno" />


                                </div>
                            </div>
                        ))
                    }
                    <div className="col-12">
                        <div className="view-all center">
                            <Link className="btn-action style-2" to="/servicios-rodex">
                                Ver Servicios
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Servicios;